import axios from 'axios';

export const domain = process.env.REACT_APP_BASE_URL;

export const api = axios.create({
  baseURL: domain,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});
